
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(136|267|559|617)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
